import {
  laptopMinXL,
  laptopMediumMax,
  tabletMin,
  mobileXLargeMin,
  mobileXLargeMax,
  mobileXXLargeMax,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { Container as Button } from '../buttons/Button.style';
import { Text } from '../typography';

export const Container = styled.div<{ $box?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 30px 0;
  flex-direction: column;

  @media (${laptopMinXL}), (${laptopMediumMax}) and (${tabletMin}) {
    flex-direction: row;
  }

  ${({ $box }) =>
    $box
      ? css`
          @media (${laptopMediumMax}) {
            margin: 30px auto;
            max-width: 460px;
          }
        `
      : css`
          @media (${tabletMax}) {
            margin: 15px 0;
          }
        `}
`;

export const Item = styled.div`
  flex: 1;
`;

export const ItemContainer = styled.div<{ colour: string; box?: boolean }>`
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-radius: 10px;
  background-color: ${({ colour }) => colour};

  ${Text} {
    color: ${({ theme }) => theme.textDark};
  }

  ${({ box }) =>
    box
      ? css`
          border: 1px solid #dedede;
          flex-direction: column;
        `
      : css`
          @media (${mobileXLargeMax}) {
            flex-direction: column;
            align-items: flex-start;

            ${Text}:last-child {
              max-width: 300px;
            }
          }
        `}
`;

export const ItemContent = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  color: ${({ theme }) => theme.textDark};

  @media (${mobileXXLargeMax}) {
    svg {
      display: none !important;
    }
  }
`;

export const CompareNiLogo = styled.img`
  height: 58px;
  width: 100px;

  @media (max-width: 350px) {
    height: auto;
    width: 90px;
  }
`;

export const CavendishLogo = styled.img`
  height: 58px;
  width: 148px;

  @media (max-width: 350px) {
    height: auto;
    width: 90px;
  }
`;

type LogoContainerProps = { mw?: number; justify?: string };

export const LogoContainer = styled.div<LogoContainerProps>`
  display: inline-flex;
  align-items: center;

  @media (${mobileXLargeMin}) {
    min-width: ${({ mw }) => mw || 148}px;
    justify-content: ${({ justify }) => justify || 'center'};
  }

  @media (${mobileXLargeMax}) {
    justify-content: center;
    margin-top: 10px;
  }
`;

export const ButtonContainer = styled.div<LogoContainerProps>`
  margin-top: 10px;

  ${Button} {
    max-width: 400px;
  }
`;
